import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

export const EASE_SMOOTH = [0.22, 1, 0.36, 1];

export const VIEWPORT = {
  once: true,
  amount: 0.18,
  margin: '0px 0px -48px 0px',
};

const motionTags = {
  div: motion.div,
  section: motion.section,
  article: motion.article,
  li: motion.li,
  header: motion.header,
  aside: motion.aside,
};

export function ScrollReveal({
  children,
  className,
  delay = 0,
  y = 36,
  duration = 0.55,
  as = 'div',
  ...rest
}) {
  const reduceMotion = useReducedMotion();
  const Tag = as;

  if (reduceMotion) {
    return (
      <Tag className={className} {...rest}>
        {children}
      </Tag>
    );
  }

  const MotionTag = motionTags[as] || motion.div;

  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={VIEWPORT}
      transition={{ duration, delay, ease: EASE_SMOOTH }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
}

export function ScrollRevealStagger({
  children,
  className,
  stagger = 0.1,
  delayChildren = 0.08,
  as = 'div',
  ...rest
}) {
  const reduceMotion = useReducedMotion();
  const Tag = as;

  if (reduceMotion) {
    return (
      <Tag className={className} {...rest}>
        {children}
      </Tag>
    );
  }

  const MotionTag = motionTags[as] || motion.div;

  return (
    <MotionTag
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={VIEWPORT}
      variants={{
        hidden: {},
        visible: {
          transition: { staggerChildren: stagger, delayChildren },
        },
      }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
}

export function ScrollRevealItem({
  children,
  className,
  y = 28,
  duration = 0.5,
  as = 'div',
  ...rest
}) {
  const reduceMotion = useReducedMotion();
  const Tag = as;

  if (reduceMotion) {
    return (
      <Tag className={className} {...rest}>
        {children}
      </Tag>
    );
  }

  const MotionTag = motionTags[as] || motion.div;

  return (
    <MotionTag
      className={className}
      variants={{
        hidden: { opacity: 0, y },
        visible: {
          opacity: 1,
          y: 0,
          transition: { duration, ease: EASE_SMOOTH },
        },
      }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
}
